import { useRouter } from 'next/router';
import type { ParsedUrlQuery } from 'querystring';

type QueryParamValue = ParsedUrlQuery[string];

function useQueryParams(): ParsedUrlQuery {
  const router = useRouter();
  return router.query;
}

export function getFirstQueryParam(value: QueryParamValue): string | undefined {
  if (Array.isArray(value)) {
    return value[0];
  }
  return value;
}

export default useQueryParams;
